import {useCallback, useEffect} from 'react'

import {useUser} from '~/shell/user'
import tracking from '~/tracking'

import type {UserAccessRequest} from './types'

export const useAccessRequestsViewedTrackingEffect = (
    action: 'viewed_notification' | 'opened_requests',
    numMemberRequests?: number,
    isLoading?: boolean,
) => {
    useEffect(() => {
        if (!isLoading && numMemberRequests !== undefined) {
            tracking.adminRequestApprovalActioned({
                action,
                n_member_requests: numMemberRequests,
            })
        }
    }, [action, isLoading, numMemberRequests])
}

export const trackAccessRequestsApproveAll = (requests: UserAccessRequest[]) => {
    tracking.adminRequestApprovalActioned({
        action: 'approved_all',
        n_member_requests: requests.length,
        request_ids: requests.map((r) => r.id),
        source: requests.map((r) => r.type),
    })
}

export const trackAccessRequestsDeclineAll = (requests: UserAccessRequest[]) => {
    tracking.adminRequestApprovalActioned({
        action: 'declined_all',
        n_member_requests: requests.length,
        request_ids: requests.map((r) => r.id),
        source: requests.map((r) => r.type),
    })
}

export const trackAccessRequestDecline = (request: UserAccessRequest) => {
    tracking.adminRequestApprovalDeclines({
        action: 'declined_request',
        new_member_email: request.email,
        request_id: request.id,
        source: request.type,
    })
}

export const trackAccessRequestDeclineReasonSubmitted = (
    request: UserAccessRequest,
    reason?: string,
    otherText?: string,
) => {
    tracking.adminRequestApprovalDeclines({
        action: 'decline_reason_submitted',
        new_member_email: request.email,
        reason_list: reason,
        reason_text: otherText,
        request_id: request.id,
        source: request.type,
    })
}

export const trackAccessRequestsCompleted = (numberOfRequests: number) => {
    tracking.adminRequestApprovalActioned({
        action: 'completed',
        n_member_requests: numberOfRequests,
    })
}

export const useTrackPlanUpgradeForRequestApproval = () => {
    const user = useUser()
    return useCallback(
        (successCount: number, failCount: number) =>
            tracking.uafAddMemberCompleted({
                actor_role: user?.role,
                company_id: user?.companyId,
                n_invites: successCount + failCount,
                n_invites_failed: failCount,
                n_invites_card: successCount,
                source: 'request_access',
            }),
        [user],
    )
}
